// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable func-names, prefer-destructuring */
import "babel-regenerator-runtime"
import * as cookies from "@kiwicom/cookies"
import * as perfTracker from "@kiwicom/frontend-common/utils/perfTracker"
import "@kiwicom/frontend-common/browser/babelIE10"
import "@kiwicom/frontend-common/browser/utils/customPolyfills"
import "@kiwicom/frontend-common/browser/clientConfig"
import "@kiwicom/frontend-common/browser/utils/onload"
import "@kiwicom/frontend-common/browser/utils/trackBeforeImports" // must be after config, because of cuckoo
import browserInfo from "@kiwicom/frontend-common/browser/utils/browserInfo"
import initAffiliates from "@kiwicom/frontend-common/browser/utils/initAffiliates"
import cuckoo from "@kiwicom/frontend-common/services/cuckoo/cuckoo"
import { isSetAffilId } from "@kiwicom/frontend-common/services/affilId/tools"
import { cuckooEvents } from "@kiwicom/frontend-common/consts/enums"
import constants from "@kiwicom/frontend-common/consts/config"

import store from "../browser/store"

if (__DEV__) {
  const _ = require("lodash")
  window._ = _
}

// COMMON - PART 1
// ===
perfTracker.onPageLoaded()
const timeFromBegin = perfTracker.getBeginToPageLoadedDuration()

initAffiliates()

cuckoo.track(cuckooEvents.GENERAL_PAGE_LOADED, { ...browserInfo, timeFromBegin })

// COMMON - PART 2
// ===

window.addEventListener("beforeunload", () => {
  const page = window.SP_GLOBALS.SKYPICKER_PAGE_NAME
  cuckoo.track(cuckooEvents.GENERAL_PAGE_LEFT, { page })
})

// COMMON - PART 3
// ===
if (isSetAffilId("aw")) {
  ;(function () {
    const s = document.getElementsByTagName("script")[0]
    const e = document.createElement("script")
    e.type = "text/javascript"
    // noinspection SpellCheckingInspection
    e.src = `//www.dwin1.com/${constants.affiliateWindowAdvertiserId}.js`
    e.defer = "defer"
    s.parentNode.insertBefore(e, s)
  })()
}

// Add ui to cookies, so every other request is also webview
const ui = window.getEnvParameter("ui")
if (ui) {
  cookies.save("ui", ui)
}

perfTracker.onAppInitialized()
cuckoo.track(cuckooEvents.GENERAL_PAGE_INITIALIZED, {
  timeFromBegin: perfTracker.getBeginToAppInitializedDuration(),
})

// FIXME stop using globals
window.reduxStore = store // for debugging
